// src/app/services/emailjs.service.ts
import { Injectable } from '@angular/core';
import emailjs, { EmailJSResponseStatus } from '@emailjs/browser';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailJsService {

  constructor() {
    emailjs.init(environment.emailjs.publicKey);
  }

  sendEmail(formData: any, formType: string): Promise<EmailJSResponseStatus> {
    const templateParams = {
      ...formData,
      form_type: formType,
      submission_date: new Date().toLocaleString()
    };
    return emailjs.send(
      environment.emailjs.serviceId,
      environment.emailjs.templateId,
      templateParams
    );
  }

  sendEventInvite(formData: any): Promise<EmailJSResponseStatus> {
    const templateParams = {
      name:    formData.name,
      email:   formData.email,
      zip:     '',
      role:    'Event Invitation',
      message: `Event: ${formData.eventName}\nDate: ${formData.eventDate}\nTime: ${formData.eventTime || 'Not specified'}\nLocation: ${formData.eventLocation}\nOrganization: ${formData.organization || 'Not specified'}\nExpected Attendance: ${formData.attendance || 'Not specified'}\n\nDetails:\n${formData.details}`,
      form_type:       'Event Invitation',
      submission_date: new Date().toLocaleString()
    };
    return emailjs.send(
      environment.emailjs.serviceId,
      environment.emailjs.templateId,
      templateParams
    );
  }

  sendPhoneBankResult(data: {
    volunteerName: string;
    volunteerEmail: string;
    phoneNumber: string;
    outcome: string;
    interested: string;
    wantsInfo: string;
    callbackRequested: boolean;
    notes: string;
    callCount: number;
  }): Promise<EmailJSResponseStatus> {
    const templateParams = {
      name:    data.volunteerName,
      email:   data.volunteerEmail,
      zip:     '',
      role:    'Phone Banker',
      message: `📞 PHONE BANK RESULT\n\nVolunteer: ${data.volunteerName} (${data.volunteerEmail})\nCall #${data.callCount} in this session\nNumber Called: ${data.phoneNumber}\n\nOutcome: ${data.outcome}\nInterested in supporting: ${data.interested}\nWants more info: ${data.wantsInfo}\nRequested callback: ${data.callbackRequested ? 'YES' : 'No'}\n\nNotes:\n${data.notes || 'None'}`,
      form_type:       'Phone Bank Result',
      submission_date: new Date().toLocaleString()
    };
    return emailjs.send(
      environment.emailjs.serviceId,
      environment.emailjs.templateId,
      templateParams
    );
  }

  // Used for petition mail requests
  sendPetitionRequest(formData: any): Promise<EmailJSResponseStatus> {
    // Maps petition fields into existing template variables so no
    // EmailJS template changes are needed.
    const templateParams = {
      name:    formData.name,
      email:   formData.email,
      zip:     formData.zip,
      role:    'Constitutional Captain (Canvassing Packet Mail Request)',
      message: `Mailing Address: ${formData.address}, ${formData.city}, MI ${formData.zip}\nCounty: ${formData.county}\nPhone: ${formData.phone || 'Not provided'}\nCanvassing Packets Requested: ${formData.quantity}`,
      form_type:       'Canvassing Packet Mail Request',
      submission_date: new Date().toLocaleString()
    };
    return emailjs.send(
      environment.emailjs.serviceId,
      environment.emailjs.templateId,
      templateParams
    );
  }
}
